function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import App from 'modules/App';
var _React_PureComponent;
class CountryIdFormPartial extends (_React_PureComponent = React.PureComponent) {
    render() {
        const countries = this.props.countries.filter((country)=>country.region === this.props.region.name).map((country)=>{
            country.label = get(this.props.localizationResources, [
                country.nameKey,
                'value'
            ]) || country.englishName;
            return country;
        }).sort((country, lastCountry)=>country.label.localeCompare(lastCountry.label));
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "countryId",
            labelMessage: App.messages.labels.country,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(Select, {
                optionsFrom: countries,
                valueKey: "countryId",
                labelKey: "label",
                noValueMessage: App.messages.placeholders.country,
                isDisabled: this.props.isDisabled,
                onChange: this.props.onSetFormValue
            })
        });
    }
}
_define_property(CountryIdFormPartial, "propTypes", {
    // Explicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    formValues: PropTypes.object,
    isDisabled: PropTypes.bool,
    // Explicit actions
    onSetFormValue: PropTypes.func,
    // Implicit props
    region: App.shapes.region,
    localizationResources: PropTypes.object
});
const mapStateToProps = (state)=>({
        region: App.selectors.region(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const ConnectedCountryIdFormPartial = connect(mapStateToProps)(CountryIdFormPartial);
export default ConnectedCountryIdFormPartial;
